var map = {
	"./addPhoto.svg": "19a0",
	"./call-icon.svg": "61be",
	"./done.svg": "2e1f",
	"./home-icon.svg": "45c6",
	"./id-icon.svg": "292d",
	"./logo.svg": "9b19",
	"./new.svg": "9cca",
	"./place.svg": "1251",
	"./process.svg": "d91e",
	"./sign-out-icon.svg": "6e21",
	"./well-done-logo.svg": "486c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";